import React, { useState, useEffect } from "react";
import UserMenu from "../../components/Layout/UserMenu";
import Layout from "./../../components/Layout/Layout";
import axios from "axios";
import "../../Styles/sell.css";
import toast from "react-hot-toast";
import { useAuth } from "../../context/auth";
import { Link } from "react-router-dom";
const ProductsSold = () => {
  const [products, setProducts] = useState([]);
  const [auth] = useAuth();

  //getall products
  const getAllProducts = async () => {
    try {
      const { data } = await axios.get(
        "https://wear2care.onrender.com/api/v1/product/get-product"
      );
      setProducts(data.products);
    } catch (error) {
      console.log(error);
      toast.error("Someething Went Wrong");
    }
  };

  //lifecycle method
  useEffect(() => {
    getAllProducts();
  }, []);
  return (
    <Layout>
      <div className="row dashboard">
        <div className="col-md-3">
          <UserMenu />
        </div>
        <div className="col-md-9 list-p ">
          <h1 className="text-center">All Products List</h1>
          <div className="d-flex flex-wrap">
            {products
              ?.filter((p) => p.userId === auth?.user?.email)
              .map((p) => (
                <Link
                  key={p._id}
                  to={`/dashboard/user/product-sold/${p.slug}`}
                  className="product-link"
                >
                  <div className="card m-2" style={{ width: "18rem" }}>
                    <img
                      src={`https://wear2care.onrender.com/api/v1/product/product-photo/${p._id}`}
                      className="card-img-top"
                      alt={p.name}
                    />
                    <div className="card-body">
                      <h5 className="card-title">{p.name}</h5>
                      <p className="card-text">
                        {p.description.substring(0, 30)}
                      </p>
                    </div>
                  </div>
                </Link>
              ))}
          </div>
          <h1 className="text-center">Donated Products</h1>
          <div className="d-flex flex-wrap">
            {products
              ?.filter(
                (p) => p.userId === auth?.user?.email && p.donation === true
              )
              .map((p) => (
                <Link
                  key={p._id}
                  to={`/dashboard/users/product-sold/${p.slug}`}
                  className="product-link"
                >
                  <div className="card m-2" style={{ width: "18rem" }}>
                    <img
                      src={`https://wear2care.onrender.com/api/v1/product/product-photo/${p._id}`}
                      className="card-img-top"
                      alt={p.name}
                    />
                    <div className="card-body">
                      <h5 className="card-title">{p.name}</h5>
                      <p className="card-text">{p.description}</p>
                    </div>
                  </div>
                </Link>
              ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ProductsSold;
